/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssayEnvelopeReviewCompletionIn } from '../models/AssayEnvelopeReviewCompletionIn';
import type { AssayEnvelopeReviewOut } from '../models/AssayEnvelopeReviewOut';
import type { AssayEnvelopeReviewResetIn } from '../models/AssayEnvelopeReviewResetIn';
import type { AssayEnvelopeReviewSaveIn } from '../models/AssayEnvelopeReviewSaveIn';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AssayEnvelopeReviewService {
    /**
     * Get Review
     * @returns AssayEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static getReviewProjectsProjectIdAssayEnvelopesFilesFileIdReviewGet({
        projectId,
        fileId,
    }: {
        projectId: number,
        fileId: string,
    }): CancelablePromise<AssayEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/review',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Review
     * @returns AssayEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static saveReviewProjectsProjectIdAssayEnvelopesFilesFileIdReviewPut({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: AssayEnvelopeReviewSaveIn,
    }): CancelablePromise<AssayEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/review',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Review Completion
     * @returns AssayEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static setReviewCompletionProjectsProjectIdAssayEnvelopesFilesFileIdReviewCompletionPut({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: AssayEnvelopeReviewCompletionIn,
    }): CancelablePromise<AssayEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/review/completion',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `The assay review or QA/QC settings changed during evaluation.`,
                422: `QA/QC blocks completion or the request is invalid.`,
                503: `Authoritative QA/QC evaluation or review storage is unavailable.`,
            },
        });
    }
    /**
     * Reset Review
     * @returns AssayEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static resetReviewProjectsProjectIdAssayEnvelopesFilesFileIdReviewResetPost({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: AssayEnvelopeReviewResetIn,
    }): CancelablePromise<AssayEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/review/reset',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
